
import designIframe from './designIframe'
let actions_ghost = {}
let modules_ghost = {}

Object.keys(designIframe.actions).map(key => {
  actions_ghost[key] = ({ dispatch }, payload) => {
    dispatch("design/postToChildren", {
      func: key,
      payload,
    }, { root: true })
  }
})

Object.keys(designIframe.modules).map(module => {
  let module_actions_ghost = {}
  Object.keys(designIframe.modules[module].actions).map(key => {
    module_actions_ghost[key] = ({ dispatch }, payload) => {
      dispatch("design/postToChildren", {
        func: module+'/'+key,
        payload,
      }, { root: true })
    }
  })
  modules_ghost[module] = {
    namespaced: true,
    state: () => ({}),
    getters: {},
    actions: {
      ...module_actions_ghost
    },
    mutations: {},
  }
})

const state = {
};

const getters = {
};

const actions = {
  ...actions_ghost
};

const mutations = {

};

const modules = {
  ...modules_ghost
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules
};
